import {
    LANGUAGES,
    LOCAL_STORAGE_THEME,
    DARK,
    LIGHT,
} from "const"
import { MtTranslation } from "server/models"
import { LangIndex, ThemeType } from "client/utils"
import { GET, POST } from "client/store/utils"
import Lang from "client/store/lang"
import { TranslationList } from "./types"


export const defineTheme = () => {
    const theme = window.localStorage.getItem(LOCAL_STORAGE_THEME) as ThemeType
    switch (theme) {
        case DARK:
            return DARK
        case LIGHT:
            return LIGHT
        default:
            return DARK
    }
}

export const LoadLang = (langId: LangIndex) => (
    LoadAllTranslations().then((translationList) => {
        if (langId && LANGUAGES.includes(langId)) {
            return ({
                ...Lang,
                ...translationList[langId],
            })
        }
        return Lang
    })
)

export const LoadAllTranslations = () => (
    GET("/mtTranslation/all")
    .then((translations: MtTranslation[]) => {
        // parse DB rows
        const translationsParsed: TranslationList = {}
        translations.forEach((translation) => {
            translationsParsed[translation.lang] = translation.translation ? JSON.parse(translation.translation) : null
        })

        // fill translationList according to LANGUAGES
        const translationList: TranslationList = {}
        LANGUAGES.forEach((row) => {
            const langId = row as LangIndex
            translationList[langId] = translationsParsed[langId] || {}
        })
        return translationList
    })
)

export const SaveTranslations = (translationList: TranslationList) => {
    const data: MtTranslation[] = []
    LANGUAGES.forEach((row) => {
        const lang = row as LangIndex
        data.push({
            lang,
            translation: translationList[lang] ? JSON.stringify(translationList[lang]) : JSON.stringify({}),
        })
    })
    return POST(
        "/mtTranslation/save",
        JSON.stringify(data),
    )
}
